import { SynchronizedTime } from '@exodus/basic-utils'
import ms from 'ms'

import getSenderNonceKey from './get-sender-nonce-key.js'

export const UNCONFIRMED_TX_LIMIT = ms('5m')

const mapToObject = (map) => Object.fromEntries(map.entries()) // only for string keys

export default function getDeriveTransactionsToCheck({ getTxLog }) {
  return async ({ assetName: _assetName, walletAccount, tokens, ourWalletAddress }) => {
    const pendingTransactionsToCheck = new Map()
    const pendingTransactionsGroupedByAddressAndNonce = new Map()
    const simulatedTransactions = new Map()
    const now = SynchronizedTime.now()

    for (const assetName of [_assetName, ...tokens.map(({ name }) => name)]) {
      const txSet = await getTxLog({ assetName, walletAccount })
      for (const tx of txSet) {
        // ERC20 sends have an entry in ETH and one in the ERC20 log so we just want the ETH one
        if (
          !pendingTransactionsToCheck.has(tx.txId) &&
          tx.pending &&
          now - tx.date.getTime() > UNCONFIRMED_TX_LIMIT
        ) {
          pendingTransactionsToCheck.set(tx.txId, { tx, assetName })
        }

        if (tx.meta.simulated) simulatedTransactions.set(tx.txId, tx)

        const senderNonceKey = getSenderNonceKey(tx, ourWalletAddress)
        if (
          tx.pending &&
          !pendingTransactionsGroupedByAddressAndNonce.has(senderNonceKey) &&
          !tx.dropped
        ) {
          pendingTransactionsGroupedByAddressAndNonce.set(senderNonceKey, {
            tx,
            replaced: false,
            assetName,
          })
        }
      }
    }

    return {
      pendingTransactionsToCheck: mapToObject(pendingTransactionsToCheck),
      pendingTransactionsGroupedByAddressAndNonce: mapToObject(
        pendingTransactionsGroupedByAddressAndNonce
      ),
      simulatedTransactions: mapToObject(simulatedTransactions),
    }
  }
}
